// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"411":"69cc74f8","533":"94b6516c","653":"63a44222","662":"4908b387","696":"f840ca6c"}[chunkId] + ".chunk.css";
};